module.exports = __webpack_public_path__ + "img/rd+-ur3.2fdca990.jpg";